export default {
	methods: {
		downloadFile (url, fileName) {
			fetch(url)
				.then(response => response.blob())
				.then(blob => {
					const link = document.createElement('a')
					link.href = URL.createObjectURL(blob)
					link.download = fileName
					link.click()
				})
		},
		downloadJsonFile (data, fileName) {
			const dataStr = JSON.stringify(data, null, 2)
			const blob = new Blob([dataStr], { type: 'application/json' })
			const url = URL.createObjectURL(blob)

			const link = document.createElement('a')
			link.href = url
			link.download = fileName
			link.click()

			URL.revokeObjectURL(url)
		}
	}
}
